/**
 * @file CV mode switch controller
 * @author Gonzalo Alvarez de Aldecoa <gon@galdecoa.com>
 * @license GPL-3.0-or-later
 * @version 2310.01.001
 */

/** @module gamemodeswitch */

/**
 * A mode switcher class.
 */
class ModeSwitch {

	/**
	 * @type {module:game~Game?}
	 */
	#game = null;

	/**
	 * @type {HTMLElement?}
	 */
	#menu = null;

	/**
	 * @type {NodeList?}
	 */
	#modeOptions = null;

	/**
	 * Forces the initial state to "game" mode.
	 */
	#setStateToGame() {
		for( let o = this.#modeOptions.length - 1; o >= 0; o = o - 1 ) {
			const option = this.#modeOptions[ o ];
			option.checked = ( option.value == "game" );
		}
		document.documentElement.classList.remove( "text-mode" );
		document.documentElement.classList.add( "game-mode" );
	}

	/**
	 * Handle the click event on a mode option element.
	 * @param {Event} clickEvent 
	 */
	#onMenuOptionClick( clickEvent ) {
		const isGame = ( clickEvent.target.value == "game" );
		const textClassAction = isGame ? "remove": "add";
		const gameClassAction = isGame ? "add" : "remove";
		document.documentElement.classList[ textClassAction ]( "text-mode" );
		document.documentElement.classList[ gameClassAction ]( "game-mode" );
		if ( this.#game ) {
			this.#game.pause( !isGame );
		}
	}

	/**
	 * Add listeners for each mode option element.
	 */
	#addModeOptionsListeners() {
		const onMenuOptionClick = this.#onMenuOptionClick.bind( this );
		for( let o = this.#modeOptions.length - 1; o >= 0; o = o - 1 ) {
			this.#modeOptions[ o ].addEventListener( "click", onMenuOptionClick );
		}
	}

	/**
	 * A mode switcher.
	 * @param {module:game~Game} game The `Game` instance.
	 * @param {HTMLElement} menu The container for the presentation modes' `input`s.
	 */
	constructor( game, menu ) {
		this.#game = game;
		this.#menu = menu;
		this.#modeOptions = this.#menu.querySelectorAll( "input" );
		this.#setStateToGame();
		this.#addModeOptionsListeners();
	}

}

export { ModeSwitch }